import React from "react";
import Successicon from "../assets/images/Successicon.png";
import { Link, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useEffect, useRef } from "react";

function ThankYou() {
  const location = useLocation();
  const orderNo = location.state?.orderNo;

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    let W, H;
    let rafId;

    function resize() {
      W = canvas.width = window.innerWidth * devicePixelRatio;
      H = canvas.height = window.innerHeight * devicePixelRatio;
      canvas.style.width = window.innerWidth + "px";
      canvas.style.height = window.innerHeight + "px";
    }
    resize();
    window.addEventListener("resize", resize);

    if (reduceMotion) {
      return () => window.removeEventListener("resize", resize);
    }

    const colors = ["#d98e3f", "#3f6b4f", "#d9603f", "#4f7fd9", "#e8c15a"];
    const COUNT = 140;
    const particles = [];

    function makeParticle() {
      const angle = Math.random() * Math.PI * 2;
      const speed = (2 + Math.random() * 7) * devicePixelRatio;
      return {
        x: W / 2,
        y: H * 0.42,
        vx: Math.cos(angle) * speed * (0.5 + Math.random()),
        vy: Math.sin(angle) * speed - 6 * devicePixelRatio,
        size: (5 + Math.random() * 6) * devicePixelRatio,
        color: colors[Math.floor(Math.random() * colors.length)],
        shape: Math.random() > 0.5 ? "rect" : "circle",
        rotation: Math.random() * Math.PI,
        rotSpeed: (Math.random() - 0.5) * 0.3,
        gravity: 0.14 * devicePixelRatio,
        drag: 0.985,
        life: 1,
      };
    }

    for (let i = 0; i < COUNT; i++) particles.push(makeParticle());

    function step() {
      ctx.clearRect(0, 0, W, H);
      let alive = false;

      for (const p of particles) {
        if (p.life <= 0) continue;
        alive = true;

        p.vx *= p.drag;
        p.vy *= p.drag;
        p.vy += p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.rotSpeed;
        p.life -= 0.0028;

        ctx.save();
        ctx.globalAlpha = Math.max(p.life, 0);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;

        if (p.shape === "rect") {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2.4, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }

      if (alive) rafId = requestAnimationFrame(step);
    }

    rafId = requestAnimationFrame(step);

    return () => {
      window.removeEventListener("resize", resize);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <Header />
      <div className="container">
        <canvas ref={canvasRef} style={styles.canvas} />
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="thanku-outer">
              <div className="container">
                <img src={Successicon} alt="" className="img-fluid" />
                <h1>Thank You for Your Booking!</h1>
                <p>
                  Your booking has been successfully confirmed. Thank you for
                  choosing CaresAtHome. Our team will get in touch with you
                  shortly to confirm the details and assist you with the next
                  steps.
                </p>
                {orderNo && (
                  <>
                    <div className="order-no">
                      {/* <span>Order Number:</span> */}
                      <h3
                        style={{
                          color: "#13baac",
                          margin: "15px 0",
                          fontWeight: "700",
                          fontSize: "20px",
                        }}
                      >
                        Order Number: {orderNo}
                      </h3>
                    </div>
                  </>
                )}
                <Link to="/">Back to Home</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

const styles = {
  canvas: {
    position: "fixed",
    inset: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
  },
};

export default ThankYou;
